import { render } from "./ValidatorDefiMetrics.vue?vue&type=template&id=8edad250&scoped=true"
import script from "./ValidatorDefiMetrics.vue?vue&type=script&lang=js"
export * from "./ValidatorDefiMetrics.vue?vue&type=script&lang=js"

import "./ValidatorDefiMetrics.vue?vue&type=style&index=0&id=8edad250&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8edad250"],['__file',"resources/js/components/ValidatorDefiMetrics.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8edad250"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8edad250', __exports__)) {
    api.reload('8edad250', __exports__)
  }
  
  module.hot.accept("./ValidatorDefiMetrics.vue?vue&type=template&id=8edad250&scoped=true", () => {
    api.rerender('8edad250', render)
  })

}


export default __exports__